import { render, staticRenderFns } from "./modelInstrumentsModal.vue?vue&type=template&id=2994a934&"
import script from "./modelInstrumentsModal.vue?vue&type=script&lang=js&"
export * from "./modelInstrumentsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports